import { Component, Input, OnInit } from '@angular/core';
import { ModificacionClienteDTO } from '@shared/models/cliente/ModificacionClienteDTO';
import { UtilClientes } from '@shared/utiles/UtilClientes';
import {CondicionIIBB} from "@shared/enums/condicionIIBB";

@Component({
  selector: 'app-datos-nuevo-cliente',
  templateUrl: './datos-nuevo-cliente.component.html',
  styleUrls: ['./datos-nuevo-cliente.component.css']
})
export class DatosNuevoClienteComponent implements OnInit {
  CondicionIIBB = CondicionIIBB;
  @Input() modificacionesCliente: ModificacionClienteDTO;

  constructor(public utilClientes: UtilClientes) { }

  ngOnInit() {
    var m = this.modificacionesCliente;// eslint-disable-line
  }


}
